import { useMemo } from 'react';
import { capitalizeFirstLetter, Field, FieldTypes } from '@common-fe/common-fe';

import { EMPTY_FIELD_VALUE } from '@/common/constants';
import { LockboxPaymentMethod, lockboxReasonTitle, LockboxStatus, lockboxWireStatusTitle } from '@/modules/employer/components/Lockbox/lockbox.types';
import useLockboxDetailsStore from '@/modules/employer/components/Lockbox/LockboxDetails/stores/useLockboxDetails.store';

const useOutboundStatusFields = () => {
  const { originalLockbox } = useLockboxDetailsStore();
  const lockboxStatus = originalLockbox?.lockboxStatus;
  const statusTitle = capitalizeFirstLetter(lockboxStatus || '');
  const reasonTitle = useMemo(() => originalLockbox?.reason
    ? lockboxReasonTitle?.[originalLockbox?.reason]
    : '', [originalLockbox?.reason]);
  const wireStatusTitle = useMemo(() => originalLockbox?.wireStatusType
    ? lockboxWireStatusTitle?.[originalLockbox?.wireStatusType]
    : '', [originalLockbox?.wireStatusType]);

  // @ts-ignore
  const fields: Field[] = useMemo(() => {
    if (lockboxStatus === LockboxStatus.APPROVED
      || lockboxStatus === LockboxStatus.COMPLETED) {
      return [
        {
          type: FieldTypes.Text,
          name: 'approvalStatus',
          label: 'Approval status',
          value: statusTitle || EMPTY_FIELD_VALUE,
        },
        {
          type: FieldTypes.Text,
          name: 'paymentMethod',
          label: 'Payment method',
          value: capitalizeFirstLetter(originalLockbox?.paymentMethodType || '') || EMPTY_FIELD_VALUE,
        },
        ...(originalLockbox?.paymentMethodType === LockboxPaymentMethod.WIRE ? [{
          type: FieldTypes.Text,
          name: 'wireStatus',
          label: 'Wire status',
          value: wireStatusTitle || EMPTY_FIELD_VALUE,
        }] : []),
        ...(originalLockbox?.paymentMethodType === LockboxPaymentMethod.CHECK ? [{
          type: FieldTypes.Text,
          name: 'checkId',
          label: 'Check ID',
          value: originalLockbox?.checkId || EMPTY_FIELD_VALUE,
        }] : []),
      ];
    }

    if (lockboxStatus === LockboxStatus.DECLINED) {
      return [
        {
          type: FieldTypes.Text,
          name: 'reason',
          label: 'Reason',
          value: reasonTitle || EMPTY_FIELD_VALUE,
        },
        {
          type: FieldTypes.Text,
          name: 'approvalStatus',
          label: 'Approval status',
          value: statusTitle || EMPTY_FIELD_VALUE,
        },
        {
          type: FieldTypes.Text,
          name: 'note',
          label: 'Note',
          value: originalLockbox?.notes || EMPTY_FIELD_VALUE,
        },
      ];
    }

    if (lockboxStatus === LockboxStatus.PENDING) {
      return [
        {
          type: FieldTypes.Text,
          name: 'reason',
          label: 'Reason',
          value: reasonTitle || EMPTY_FIELD_VALUE,
        },
        {
          type: FieldTypes.Text,
          name: 'approvalStatus',
          label: 'Approval status',
          value: statusTitle || EMPTY_FIELD_VALUE,
        },
        {
          type: FieldTypes.Text,
          name: 'note',
          label: 'Note',
          value: originalLockbox?.notes || EMPTY_FIELD_VALUE,
        },
      ];
    }

    if (lockboxStatus === LockboxStatus.CANCELED) {
      return [
        {
          type: FieldTypes.Text,
          name: 'approvalStatus',
          label: 'Approval status',
          value: statusTitle || EMPTY_FIELD_VALUE,
        },
        {
          type: FieldTypes.Text,
          name: 'note',
          label: 'Note',
          value: originalLockbox?.notes || EMPTY_FIELD_VALUE,
        },
      ];
    }

    return [];
  }, [lockboxStatus, originalLockbox, statusTitle, reasonTitle, wireStatusTitle]);

  return fields;
};

export default useOutboundStatusFields;
